import { render, staticRenderFns } from "./SocialLiveStreamingCard.vue?vue&type=template&id=4c8d2b09&scoped=true"
import script from "./SocialLiveStreamingCard.vue?vue&type=script&lang=js"
export * from "./SocialLiveStreamingCard.vue?vue&type=script&lang=js"
import style0 from "./SocialLiveStreamingCard.vue?vue&type=style&index=0&id=4c8d2b09&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c8d2b09",
  null
  
)

export default component.exports